import { Icon } from '@flippingbook/web.react-kit/dist/Icon';
import { InfoBox } from '@flippingbook/web.react-kit/dist/InfoBox';
import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import type { To } from 'react-router-dom';

import { loc } from '@/localization';
import { Link } from '@/site/components/Link';

import { e } from './style.css';

export function ErrorBox({ loginUrl, restoreUrl }: { loginUrl: To; restoreUrl: To }) {
    return (
        <InfoBox
            theme="red"
            iconPosition="middle"
            icon={<Icon name="warning" />}
            className={e.errorBox}
        >
            <p className={e.errorBoxContent}>{loc.Login.SignupLoginErrorTitle}</p>
            <ul className={e.errorBoxContent}>
                <li>{loc.Login.SignupLoginErrorOptionNewEmail}</li>
                <li>
                    <L10n
                        text={loc.Login.SignupLoginErrorOptionLoginOrRestore}
                        replaces={[
                            ['{doLogin}', <Link to={loginUrl}>{loc.Login.DoLogin}</Link>],
                            ['{doReset}', <Link to={restoreUrl}>{loc.Login.DoResetPassword.toLowerCase()}</Link>],
                        ]}
                    />
                </li>
            </ul>
        </InfoBox>
    );
}
